<ng-container *ngIf="patient">
  <button class="primary button" [disabled]="disabled" (click)="createFollowupCompleteModal(patient)">
    Complete
  </button>
</ng-container>
